/*jshint esversion: 6 */

import Barba from 'barba.js/src';
const $ = require('jquery');
import {TweenMax, TimelineMax, Power4, Power2, Expo} from "gsap";
import CustomEase from '../../../vendors/CustomEase';
import PubSub from 'pubsub-js';

export function homeToDetailAnimation(context, resolve, reject) {
    const element = $('a[href="' + Barba.HistoryManager.currentStatus().url.replace(/\/app$/, '') + '"]').closest('.page'),
            pageContainerFront = element.closest('.pages-container'),
            pageContainerBack = pageContainerFront.siblings('.container--back'),
            navigation = pageContainerFront.closest('.horizontal-scroll').siblings('.horizontal-scroll--navigation'),
            backElement = $(pageContainerBack).children().eq(element.index());

    if(!element.length) {
        location.reload();
    }
        
    element.trigger('mouseenter');
        
    element.find('a').remove();
    PubSub.publish('RemoveScrollEvents');
    
    let offset = element.offset().left;
    const delay = 0.2;
    
    element.find('.page--inner-wrapper').width(element.width());
    backElement.find('.page--inner-wrapper').width(element.width());

    TweenMax.staggerTo(
        element.find('p').get().reverse(),
        0.6, {y: 0, autoAlpha: 0, ease: Expo.easeInOut, delay: 0.1}, 0.04
    );
    TweenMax.staggerTo(element.find('h2'), 0.4, {y: 100, autoAlpha: 0, ease: Expo.easeInOut});
    TweenMax.to(backElement.find('.page--image'), 0.3, {y: '10%', x: '-20%', scale: 0.8, autoAlpha: 0, ease: Expo.easeInOut});
    TweenMax.to(navigation.find('.navigation--left'), 0.5, {x: -100, delay, ease: Expo.easeIn});
    TweenMax.to(navigation.find('.navigation--right'), 0.5, {x: 100, delay, ease: Expo.easeIn});
    
    TweenMax.to([element, backElement], 0.6, {width: window.innerWidth, x: -offset, delay, ease: Expo.easeIn});
    if(offset > 0) {
        TweenMax.to([element.prevAll().slice(0, 3), backElement.prevAll().slice(0, 3)], 0.6, {x: -window.innerWidth, delay, ease: Expo.easeIn});        
    }
    TweenMax.to([element.nextAll().slice(0, 3), backElement.nextAll().slice(0, 3)], 0.6, {x: window.innerWidth - offset, delay, ease: Expo.easeIn});
    
    TweenMax.fromTo(backElement.find('.page--logo'), 0.8,
        {autoAlpha: 0, y: 100},
        {
            y:0, autoAlpha: 1, delay: delay+0.4, ease: Power4.easeInOut,
            onComplete: () => { resolve() }
        }
    );
}

export function homeToDetailAnimationNext() {
    const $el = $(this.newContainer),
        _this = this,
        masks = $el.find('.page--masks'),
        logo = $el.find('.page--logo'),
        letters = $el.find('.page-title p'),
        pageBanner = $el.find('.page-banner .page-background .page-background--background-image'),
        maskEase = CustomEase.create("custom", "M0,0,C0.29,0,0.252,0.344,0.29,0.502,0.38,0.982,0.704,1,1,1");
    
    // $('#siteHeader').addClass('inverse');

    letters.addClass('initialized').each((index, p) => {
        p.innerHTML = $(p).text().replace(/(\W|\w)/g, `<span>$&</span>`);
    });
    pageBanner.removeClass('initial-load');
    
    masks.removeClass('no-js');
    
    $(this.oldContainer).hide();

    const tl = new TimelineMax();

    tl.set(pageBanner, {x: '-23%'});
    tl.set(pageBanner.siblings('.overlay'), {autoAlpha: 0});
    tl.set(logo, {autoAlpha: 1});
    TweenMax.set(letters.find('span'), {y: 100});

    TweenMax.to(logo, 0.4, {ease :Power4.easeInOut, autoAlpha: 0, y: -100});
    tl.to([masks.find('span.top'), masks.find('span.bottom')], 1, {height: 100, ease: maskEase, delay: 0.2});
    tl.to(masks.find('span.right'), 1, {width: 150, ease: maskEase, delay: 0.2}, 0);
    tl.to(pageBanner, 1, {x: '0%', ease: maskEase, delay: 0.2}, 0);

    setTimeout(function() {
        TweenMax.staggerTo(letters.find('span'), 1, { y: 0, ease: maskEase}, 0.015);
    }, 500);
    
    tl.to([masks.find('span.top'), masks.find('span.bottom')], 0.6, {height: 0, ease: Power4.easeInOut, delay: 1.1}, 0);
    tl.to(masks.find('span.right'), 0.6, {width: 0, ease: Power4.easeInOut, delay: 1.1}, 0);
    tl.to(pageBanner, 1.2, {scale: 1.1, ease: maskEase, delay: 1.1}, 0);
    tl.to(pageBanner.siblings('.overlay'), 1.2, {autoAlpha: 1, delay: 1.1}, 0);
    this.done();
}


// WEBPACK FOOTER //
// ./app/components/scrolling/DJAX_animations/homeToDetail.js